import React from 'react';
import './FilterButton.css';

function FilterButton({ onClick, filterBy, results, isActive, isWhite }) {
	const whiteStyles = {
		color: 'white',
		marginTop: '19px',
		cursor: 'pointer',
		':hover': {
			color: '#9ca49e !important',
		},
	};

	return (
		<>
			<button
				className={` ${isWhite ? 'filter-button-white ' : 'filter-button'} ${
					isActive ? (isWhite ? 'is-active-white' : 'is-active') : ''
				}`}
				style={isWhite && whiteStyles}
				onClick={onClick}
			>
				<div>{filterBy}</div>
				<span className='filter-results'> {results} Results</span>
			</button>

			{isWhite && <div style={{ borderBottom: '1px solid #fff' }} />}
		</>
	);
}

export default FilterButton;
